import React, { useCallback, useEffect, useState } from 'react';
import { Checkbox } from '@fluentui/react-components';
import { useBrandDetectionConfirmationStyle } from './style';

export const BrandDetectionConfirmation = ({
  i18n, brandName, onConfirm, logger, renderHelpButton,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const classes = useBrandDetectionConfirmationStyle();

  const onChange = useCallback((evt, data) => {
    if (data.checked && onConfirm) {
      logger.logTrace(`BrandDetectionConfirmation: confirmed to skip brand name: ${brandName}`);
      setTimeout(() => {
        onConfirm();
      }, 1000);
    }
    setIsChecked(data.checked);
  }, [brandName, logger, onConfirm]);

  useEffect(() => {
    logger.logTrace(`BrandDetectionConfirmation: brand name detected: ${brandName}`);
  }, [brandName, logger]);

  return (
    <div className={classes}>
      <div className="ai-warning-icon" />
      <div className="confirmation-content">
        <div className="confirmation-content-title">{i18n.getString(_TL_('Brand detected: Image contains "{{brandName}}"'), { brandName })}</div>
        <div className="confirmation-content-text">{i18n.getString(_TL_('Note: Your request for the image may contain content that is subject to the intellectual property rights of third parties.'))}</div>
        <div className="confirmation-content-action">
          <Checkbox
            label={i18n.getString(_TL_('I hereby represent and warrant that my use of the image(s) generated through my usage of Microsoft Advertising does not infringe upon the intellectual property rights of any third party.'))}
            className="confirmation-content-checkbox"
            onChange={onChange}
            checked={isChecked}
          />
          {renderHelpButton && renderHelpButton('pop_BA_AssetLibrary_BrandDetection')}
        </div>
      </div>
    </div>
  );
};
